import { DEFAULT_HERO_EYEBROW, type HeroModuleProps } from "./renderProps";
import { renderTextWithLineBreaks } from "./text";

export function HeroModule({
  eyebrow,
  headline,
  body,
  image,
}: HeroModuleProps) {
  const eyebrowText = eyebrow?.trim() || DEFAULT_HERO_EYEBROW;

  return (
    <section className="cms-hero" data-cms-module="hero">
      <div className="cms-wrap">
        <div className="cms-hero__layout">
          <div className="cms-hero__content">
            <p className="cms-hero__eyebrow">
              <span className="cms-hero__eyebrow-rule" aria-hidden="true" />
              {renderTextWithLineBreaks(eyebrowText)}
            </p>
            <h1>{renderTextWithLineBreaks(headline)}</h1>
            {body ? (
              <p className="cms-hero__body">{renderTextWithLineBreaks(body)}</p>
            ) : null}
          </div>
          {image ? (
            <figure className="cms-hero__image">
              <img src={image.src} alt={image.alt} />
              {image.caption ? <figcaption>{image.caption}</figcaption> : null}
            </figure>
          ) : null}
        </div>
      </div>
    </section>
  );
}
